module.exports = __webpack_public_path__ + "media/images/icon__settings@3x-90d1df0a25c58dda4e71d1386539afc6.png";